interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface GridPoint {
  x: number;
  y: number;
}

export const frameAnimation = (login: HTMLDivElement, box: HTMLFormElement): GridPoint[] => {
  const loginRect = login.getBoundingClientRect();

  const outer: Rect = {
    x: 0,
    y: 0,
    width: login.clientWidth,
    height: login.clientHeight,
  };

  const innerRect = box.getBoundingClientRect();
  const inner: Rect = {
    x: innerRect.x - loginRect.x, // ← переводим в координаты login
    y: innerRect.y - loginRect.y, // ← переводим в координаты login
    width: box.clientWidth,
    height: box.clientHeight,
  };

  return getValidGridPoints(outer, inner);
};

function getValidGridPoints(outer: Rect, inner: Rect, step: number = 120): GridPoint[] {
  const points: GridPoint[] = [];

  const left = outer.x;
  const top = outer.y;
  const right = outer.x + outer.width;
  const bottom = outer.y + outer.height;

  for (let x = left; x + step <= right; x += step) {
    for (let y = top; y + step <= bottom; y += step) {
      // Проверяем, пересекается ли блок с внутренним прямоугольником
      const intersects = !(
        x + step <= inner.x || // блок полностью слева
        x >= inner.x + inner.width || // блок полностью справа
        y + step <= inner.y || // блок полностью сверху
        y >= inner.y + inner.height // блок полностью снизу
      );

      if (!intersects) {
        points.push({ x, y });
      }
    }
  }

  return points;
}
